import React, { useState } from 'react';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Folder } from '../../../../../../constants/APIs';
import {
    Input,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Row,

} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
export default function DeleteFolder({
    visible,
    toggleModal,
    selectedFolder,
    parentLoadData,
    folderName,
    folderId,
    deleteFolderById
}) {

    const handleDeleteFolder = () => {

        let body = {
            creator: 'dashboard',
            folderName: folderName,
            status: 'Draft',
            folderPath: selectedFolder,
        };

        const id = folderId;
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Folder}/${id}`,
            data: body,
        })
            .then((res) => {
                deleteFolderById(id);
                toggleModal();

            })
            .catch((err) => {
                console.error('Error updating folder status:', err);

            });

    };


    return (

        <Row>
            <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                <Row>
                    <Colxx xs="12" sm="3" className="mb-1">
                        <Modal isOpen={visible} toggle={toggleModal}>
                            <ModalHeader toggle={toggleModal}>
                                <span role="img" aria-label="warning">
                                    ⚠️
                                </span>
                                This Folder will be deleted!
                            </ModalHeader>
                            <ModalBody>
                                <Button
                                    color="danger"
                                    onClick={() => handleDeleteFolder()}
                                    size="xs"
                                >
                                    <IntlMessages id='dashboards.delete' />
                                </Button>
                                <Button
                                    className="ml-2"
                                    color="dark"
                                    outline
                                    size="xs"
                                    onClick={toggleModal}
                                >
                                    <IntlMessages id='pages.cancel' />
                                </Button>
                            </ModalBody>
                        </Modal>
                    </Colxx>
                </Row>
            </Colxx>
        </Row>

    );
}
